import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Download = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="download icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M18.3612 9.22564C18.7783 9.22405 19.1673 9.38562 19.4567 9.67834L19.5945 9.81773C19.8664 10.0918 20.0172 10.4583 20.0172 10.8435C20.0172 11.2462 19.8544 11.6235 19.5585 11.907L12.8332 18.3066C12.3456 18.7716 11.5551 18.7685 11.0707 18.3018L4.29155 11.7644C4.00057 11.4841 3.84 11.1084 3.84 10.7089C3.84 10.3316 3.98597 9.96979 4.25133 9.69386C4.53679 9.39797 4.92412 9.23039 5.34194 9.22722C5.75911 9.22247 6.14936 9.38087 6.44229 9.67042L10.3266 13.5432V2.52467C10.3266 1.66046 11.0438 0.960022 11.9288 0.960022C12.8134 0.960022 13.5306 1.66046 13.5306 2.52467V13.5084L17.2676 9.68309C17.5554 9.39005 17.9443 9.22722 18.3612 9.22564Z"
    />
    <path
      className={pathClass}
      d="M5.44646 20.1889H18.4534C19.3406 20.1889 20.0598 20.8271 20.0598 21.6146C20.0598 22.4018 19.3406 23.04 18.4534 23.04H5.44646C4.55918 23.04 3.84006 22.4018 3.84006 21.6146C3.84006 20.8271 4.55918 20.1889 5.44646 20.1889Z"
    />
  </svg>
)
